'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $tenant = process.env.ELECTRODE_TENANT;
var tenantMessages = void 0;

try {
	tenantMessages = require('./tenants/' + $tenant + '/default-messages'); //eslint-disable-line
} catch (err) {
	tenantMessages = {};
}

var messages = (0, _reactIntl.defineMessages)({
	APPOINTMENTS: {
		'id': 'TOP_NAV.APPOINTMENTS',
		'defaultMessage': 'Appointments'
	},
	ARE_YOU_A_SPECIALIST: {
		'id': 'TOP_NAV.ARE_YOU_A_SPECIALIST',
		'defaultMessage': 'Are you a Specialist?'
	},
	ARTICLES: {
		'id': 'TOP_NAV.ARTICLES',
		'defaultMessage': 'Articles'
	},
	CATEGORIES: {
		'id': 'TOP_NAV.CATEGORIES',
		'defaultMessage': 'Categories'
	},
	CONTACT: {
		'id': 'TOP_NAV.CONTACT',
		'defaultMessage': 'Contact'
	},
	DOCTIFY_JOURNAL: {
		'id': 'TOP_NAV.DOCTIFY_JOURNAL',
		'defaultMessage': 'Doctify Journal'
	},
	DOCTIFY_JOURNAL_LINK_TITLE: {
		'id': 'TOP_NAV.DOCTIFY_JOURNAL_LINK_TITLE',
		'defaultMessage': 'Health and medical articles from top doctors.'
	},
	FIND_A_DOCTOR: {
		'id': 'TOP_NAV.FIND_A_DOCTOR',
		'defaultMessage': 'Overriden in en.json!'
	},
	FIND_A_DOCTOR_ALT: {
		'id': 'TOP_NAV.FIND_A_DOCTOR_ALT',
		'defaultMessage': 'replace'
	},
	GET_A_REFERRAL: {
		'id': 'TOP_NAV.GET_A_REFERRAL',
		'defaultMessage': 'Get a referral'
	},
	LOG_IN: {
		'id': 'TOP_NAV.LOG_IN',
		'defaultMessage': 'Log in'
	},
	LOG_OUT: {
		'id': 'TOP_NAV.LOG_OUT',
		'defaultMessage': 'Log Out'
	},
	MY_ACCOUNT: {
		'id': 'TOP_NAV.MY_ACCOUNT',
		'defaultMessage': 'My Account'
	},
	PRIVACY_POLICY: {
		'id': 'TOP_NAV.PRIVACY_POLICY',
		'defaultMessage': 'Privacy Policy'
	},
	PROFILE_SETUP: {
		'id': 'TOP_NAV.PROFILE_SETUP',
		'defaultMessage': 'Profile Setup'
	},
	REFINE_SEARCH: {
		'id': 'TOP_NAV.REFINE_SEARCH',
		'defaultMessage': 'Refine Search'
	},
	SEARCH_JOURNAL: {
		'id': 'TOP_NAV.SEARCH_JOURNAL',
		'defaultMessage': 'Search Journal'
	},
	SIGN_UP: {
		'id': 'TOP_NAV.SIGN_UP',
		'defaultMessage': 'Sign Up'
	},
	TERMS_AND_CONDITIONS: {
		'id': 'TOP_NAV.TERMS_AND_CONDITIONS',
		'defaultMessage': 'Terms and Conditions'
	},
	WRITE_A_REVIEW: {
		'id': 'TOP_NAV.WRITE_A_REVIEW',
		'defaultMessage': 'Write a Review'
	},
	VITALITY_MEMBERZONE: {
		'id': 'TOP_NAV.VITALITY_MEMBERZONE',
		'defaultMessage': 'Vitality Memberzone'
	},
	HOSPITAL_LIST: {
		'id': 'TOP_NAV.HOSPITAL_LIST',
		'defaultMessage': 'Your Hospital List'
	},
	NOT_A_VITALITY_HEALTH_MEMBER: {
		'id': 'TOP_NAV.NOT_A_VITALITY_HEALTH_MEMBER',
		'defaultMessage': 'Not a Vitality Health member?'
	},
	SPECIALIST_FINDER: {
		'id': 'TOP_NAV.SPECIALIST_FINDER',
		'defaultMessage': 'Consultant Finder'
	},
	LINK: {
		'id': 'TOP_NAV.LINK',
		'defaultMessage': 'link'
	}
});

module.exports = (0, _assign2.default)({}, messages, tenantMessages);


// WEBPACK FOOTER //
// ./components/top-nav/lib/lang/default-messages.js